import config from "../../config";
const baseUrl = config.baseUrl;

export const ContactInfoUrls = {

  CONTACTINFO_READ: baseUrl + "/contacts_info",

};